import { getRequest, putRequest } from 'src/utils/http';
import { notificationsController } from './consts';

export const getNotifications = (params) => getRequest(`${notificationsController}/`, params);
export const markAsReadNotification = (id) => putRequest(`${notificationsController}/${id}/read`);
